// extracted by mini-css-extract-plugin
export var black = "_v-6";
export var brand = "_v-1";
export var ddefault = "_v-0";
export var error = "_v-3";
export var gray = "_v-2";
export var highContrast = "_v-8";
export var outline = "_v-7";
export var success = "_v-5";
export var warning = "_v-4";